module.exports = __webpack_public_path__ + "images/marketing/features/accel7.gif";